// components/PageNotFound.js
import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();
  const isAdmin = window.location.hostname.startsWith("admin.");

  const handleGoHome = () => {
    if (isAdmin) {
      navigate("/login");
    } else {
      navigate("/");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Result
        status="404"
        title="404"
        subTitle={isAdmin ? "Admin page not found" : "Page not found"}
        extra={
          <Button type="primary" onClick={handleGoHome}>
            {isAdmin ? "Back to Login" : "Back to Home"}
          </Button>
        }
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
        }}
      />
    </div>
  );
}

export default PageNotFound;
